import { render, staticRenderFns } from "./NoticeIndex.vue?vue&type=template&id=50519633"
import script from "./NoticeIndex.vue?vue&type=script&lang=ts"
export * from "./NoticeIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports